'use client';

import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { TableHead } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import type { SortDirection } from '@/lib/sort';

interface SortableTableHeadProps<K extends string> {
  sortKey: K;
  activeKey: K;
  direction: SortDirection;
  onSort: (key: K) => void;
  align?: 'left' | 'right';
  className?: string;
  children: React.ReactNode;
}

export function SortableTableHead<K extends string>({
  sortKey, activeKey, direction, onSort, align = 'left', className, children,
}: SortableTableHeadProps<K>) {
  const active = sortKey === activeKey;
  return (
    <TableHead
      className={cn(align === 'right' && 'text-right', className)}
      aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={cn('flex items-center hover:text-foreground cursor-pointer', align === 'right' && 'ml-auto')}
      >
        {children}
        {!active ? (
          <ArrowUpDown className="h-4 w-4 ml-1 opacity-30" />
        ) : direction === 'asc' ? (
          <ArrowUp className="h-4 w-4 ml-1" />
        ) : (
          <ArrowDown className="h-4 w-4 ml-1" />
        )}
      </button>
    </TableHead>
  );
}
